/**
 * Temporary rental gear catalog until trip-management prices are served by the API.
 * Amounts are in the trip's display currency units (historically THB-style).
 */
export const RENTAL_GEAR_PRICES = {
  bcd: 1500,
  wetsuit: 1500,
  fins: 1000,
  mask: 1000,
  regulator: 1500,
  diveComputer: 800,
  torch: 1000,
} as const;

export type RentalGearKey = keyof typeof RENTAL_GEAR_PRICES;
